import { ConnectionInstance } from './BackportPluginComponent';

export default class Connection {
  private static connections: Map<string, ConnectionInstance> = new Map();

  public static getConnection(clientId: string, iframe: HTMLIFrameElement) {
    let messageBus: any;
    const context = iframe.contentWindow;

    if (!Connection.connections.has(clientId)) {
      if (context == null) {
        throw Error(`[BackportPluginComponent] context not initialized`);
      }

      messageBus = (context as any).emb.messagebus.MessageBusConnection;
      if (messageBus == null) {
        throw Error(`[BackportPluginComponent] message bus not found`);
      }

      const connection = messageBus.connect(clientId);
      Connection.connections.set(clientId, connection);
      if (connection == null) {
        throw Error(`[BackportPluginComponent] could not establish the connection to message bus`);
      }
    }
    const connection = Connection.connections.get(clientId);
    if (connection == null) {
      throw new Error(`[BackportPluginComponent] could not create/find connection`);
    }
    return connection;
  }
}
